module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bbOAd"))).then(() => parcelRequire('hEqeo'));